import React, { useContext, useEffect, useState } from "react"
import { Button, Col, Row } from "react-bootstrap"
import { useSelector, useDispatch } from "react-redux"
import { AppDispatch } from "../../../.."
import ComboBox from "../../../../components/ComboBox"
import CheckInput from "../../../../components/InputWrapper/CheckInput"
import DateInput from "../../../../components/InputWrapper/DateInput"
import TextInput from "../../../../components/InputWrapper/TextInput"
import NumberInput from "../../../../components/InputWrapper/NumberInput"

import { TPictureFile } from "../../../../globalStore/pageStore/zyomuinMaster/baseData"
import {
  TZyomuinMasterState,
  zyomuinMasterActions,
} from "../../../../globalStore/pageStore/zyomuinMaster/zyomuinMasterStore"
import { RootState } from "../../../../globalStore/rootreducer"
import { TWijmoComboBox } from "../../../../type/wijmoComponents"
import { Table } from "react-bootstrap"
import { メニューコード } from "../../../../constant/menuCode"
import commonUtil from "../../../../ts/util/commonUtil"
import { BlobContext } from "../ZyomuinMasterRegisterContext"
import SingleFileUploadModal from "./ModalComponent/AttachedSingleFileModal"
import ConfirmModal from "../../../../components/Modal/ConfirmModal"
import dateUtil from "../../../../ts/util/dateUtil"
import WarekiInput from "../../../../components/InputWrapper/WarekiInput"
// TODO: combo設定
//#region [type]
// DefaultCombo
export type TDefaultComboItem = { name: string; value: any }

//#endregion

//#region ダミーデータ

// defaultComboBox用
const boolList: TDefaultComboItem[] = [
  {
    name: "在籍",
    value: 0,
  },
  {
    name: "離籍",
    value: 1,
  },
]

//#endregion

const MainDataPane: React.FC<{
  isLoadEnded?: boolean
  setIsLoadEnded: React.Dispatch<React.SetStateAction<boolean>>
}> = (props) => {
  //#region [selector]
  const zyomuinMaster: TZyomuinMasterState = useSelector(
    (state: RootState) => state.page.zyomuinMaster
  )

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.乗務員管理.乗務員マスタ登録
      )?.読み取り専用フラグ
  )
  const disPatch: AppDispatch = useDispatch()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  const { addBlobItem, removeBlobItem, blobList } = useContext(BlobContext)

  //#endregion

  //#region [state]
  // ComboBoxState
  const [退職フラグComboBox, set退職フラグComboBox] = useState<TWijmoComboBox<
    TDefaultComboItem["name"],
    TDefaultComboItem
  > | null>(null)
  const [退職フラグItemSource, set退職フラグItemSource] =
    useState<TDefaultComboItem[]>()
  const [退職フラグIsLoadEnded, set退職フラグIsLoadEnded] =
    useState<boolean>(false)
  // 顔写真
  const [selected顔写真, setSelected顔写真] = useState<TPictureFile>()
  const [isShowFileUploadModal, setIsShowFileUploadModal] = useState(false)
  const [isShowDeleteFileConfirmModal, setIsShowDeleteFileConfirmModal] =
    useState(false)

  // ComboBoxデータ読込フラグ
  const [comboDataInitialized, setComboDataInitialized] = useState(false)

  //#endregion

  //#region [method]

  const add顔写真 = async (file: File | undefined, fileUrl: string) => {
    if (selected顔写真 != null) {
      const updateItem = {
        ...selected顔写真,
      }
      disPatch(zyomuinMasterActions.edit顔写真(updateItem))
      setSelected顔写真(updateItem)
    } else {
      if (file != null) {
        const newFile: TPictureFile = {
          isNewFile: true,
          row_id: commonUtil.getUniqueStr(),
          ファイルURL: fileUrl,
          ファイル名: file.name,
        }
        disPatch(zyomuinMasterActions.set顔写真(newFile))

        // Fileをコンテキスト経由で保持
        addBlobItem({ id: newFile.row_id!, blob: file, fileUrl: fileUrl })
      }
    }
    setIsShowFileUploadModal(false)
  }

  const remove顔写真 = (fileData: TPictureFile) => {
    if (fileData.isNewFile) {
      // store連動
      disPatch(zyomuinMasterActions.remove顔写真(fileData))

      // コンテキスト連動
      removeBlobItem(fileData.row_id!)
    } else {
      disPatch(zyomuinMasterActions.remove顔写真(fileData))

      // コンテキスト連動
      removeBlobItem(fileData.row_id!)
    }

    setIsShowDeleteFileConfirmModal(false)
  }

  // setterを必要としない場合のダミーファンクション
  const dummyFunc = (v?: any) => {}

  //#endregion

  //#region [effect]
  useEffect(() => {
    if (退職フラグComboBox == null) return
    setComboDataInitialized(true)
  }, [退職フラグComboBox])

  useEffect(() => {
    if (!comboDataInitialized) return
    set退職フラグItemSource(boolList)
  }, [comboDataInitialized])

  useEffect(() => {
    if (!props?.setIsLoadEnded) return
    if (!退職フラグIsLoadEnded) return

    props.setIsLoadEnded(true)
  }, [退職フラグIsLoadEnded, props])

  //#endregion

  return (
    <>
      <div className="accordion-header">
        基本データ
        <div className="accordion-description"></div>
      </div>
      <div>
        <div>
          <Row>
            <Col>
              <div
                style={{
                  fontSize: "1.1rem !important",
                  borderBottom: "solid 1px #539abe",
                  margin: "0.5rem 0 1.5rem 0",
                  justifyContent: "space-between",
                  display: "flex",
                }}>
                <div id="top">基本データ</div>
                <div>
                  {zyomuinMaster.乗務員ID != null && (
                    <>
                      {zyomuinMaster.作成日時 === zyomuinMaster.更新日時
                        ? "作成日時"
                        : "更新日時"}
                      :
                      {dateUtil.format(
                        zyomuinMaster.更新日時,
                        "YYYY/MM/DD HH:mm:ss"
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="d-flex flex-row">
                <div className="min-w-55rem">
                  <Table className="form-table">
                    <tbody>
                      <tr>
                        <th className="min-w-8rem">社員CD</th>
                        <td>
                          <TextInput
                            id="社員CD"
                            name="社員CD"
                            isRequired={true}
                            isReadOnly
                            value={zyomuinMaster.社員コード}
                            setValue={dummyFunc}
                            maxLength={4}
                          />
                        </td>
                        <th className="min-w-8rem">部所名</th>
                        <td>
                          <TextInput
                            id="部所名"
                            name="部所名"
                            isRequired={true}
                            isReadOnly
                            value={zyomuinMaster.部所名}
                            setValue={(v) => {
                              //ReadOnlyの為、不要
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>氏名</th>
                        <td>
                          <TextInput
                            id="社員氏名"
                            name="社員氏名"
                            isRequired={true}
                            isReadOnly
                            value={zyomuinMaster.社員氏名}
                            setValue={(v) => {
                              //ReadOnlyの為、不要
                            }}
                          />
                        </td>
                        <th>氏名カナ</th>
                        <td>
                          <TextInput
                            id="社員氏名カナ"
                            name="社員氏名カナ"
                            isRequired={true}
                            isReadOnly
                            value={zyomuinMaster.社員氏名カナ}
                            setValue={(v) => {
                              //ReadOnlyの為、不要
                            }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <Table className="form-table">
                    <tbody>
                      <tr>
                        <th className="min-w-8rem">入社日</th>
                        <td>
                          <div className="input-group">
                            <DateInput
                              id="入社年月日"
                              value={zyomuinMaster.入社年月日}
                              setValue={dummyFunc}
                              isDisabled
                            />
                          </div>
                        </td>
                        <th className="min-w-5rem">在籍年数</th>
                        <td>
                          <TextInput
                            id="在籍年数"
                            name="在籍年数"
                            isReadOnly
                            value={dateUtil.to在籍年月数Str(
                              eigyobi,
                              zyomuinMaster.入社年月日,
                              zyomuinMaster.退職年月日
                            )}
                            setValue={(v) => {
                              //ReadOnlyの為、不要
                            }}
                          />
                        </td>
                      </tr>

                      <tr>
                        <th className="min-w-8rem">生年月日</th>
                        <td>
                          <div className="input-group">
                            <DateInput
                              id="生年月日"
                              value={zyomuinMaster.生年月日}
                              setValue={dummyFunc}
                              isDisabled
                            />
                          </div>
                        </td>
                        <th className="min-w-5rem">年齢</th>
                        <td>
                          <div className="input-group align-middle">
                            {
                              <TextInput
                                id="年齢"
                                name="年齢"
                                isReadOnly
                                value={
                                  zyomuinMaster.生年月日
                                    ? `${dateUtil.calc年齢(
                                        eigyobi,
                                        zyomuinMaster.生年月日
                                      )}歳`
                                    : ""
                                }
                                setValue={(v) => {
                                  //ReadOnlyの為、不要
                                }}
                              />
                            }
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th className="min-w-8rem">性別</th>
                        <td colSpan={3}>
                          <div className="input-group">
                            <TextInput
                              id="性別"
                              name="性別"
                              value={zyomuinMaster.性別区分名称1}
                              setValue={dummyFunc}
                              isReadOnly
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th className="min-w-8rem">血液型</th>
                        <td colSpan={3}>
                          <div className="input-group">
                            <TextInput
                              id="血液型"
                              name="血液型"
                              value={zyomuinMaster.血液型区分名称1}
                              setValue={dummyFunc}
                              isReadOnly
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th className="min-w-8rem">選任日</th>
                        <td colSpan={3}>
                          <div className="input-group">
                            <DateInput
                              id="選任日"
                              value={zyomuinMaster.選任日}
                              setValue={(v) => {
                                disPatch(zyomuinMasterActions.set選任日(v))
                              }}
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th className="min-w-8rem">選任種類</th>
                        <td colSpan={3}>
                          <div className="input-group">
                            <TextInput
                              id="選任種類"
                              name="選任種類"
                              value={zyomuinMaster.選任種類}
                              setValue={(v) => {
                                disPatch(zyomuinMasterActions.set選任種類(v))
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <div className="min-w-30rem">
                  <ul className="list-cmn d-flex w-100">
                    <li className="ps-5 w-100 h-100">
                      <Row>
                        <Col
                          className="file-thumbnail-col d-flex"
                          style={{
                            height: "25rem",
                            maxHeight: "25rem",
                            width: "30rem",
                            maxWidth: "30rem",
                            border: "2px solid var(--working-color)",
                            justifyContent: "center",
                            alignItems: "center",
                          }}>
                          {zyomuinMaster.顔写真 != null && (
                            <img
                              className="file-thumbnail mw-100 mh-100"
                              src={
                                blobList.find(
                                  (b) => b.id === zyomuinMaster.顔写真?.row_id
                                )?.fileUrl ?? ""
                              }
                              alt={zyomuinMaster.顔写真?.ファイル名}
                            />
                          )}
                          {zyomuinMaster.顔写真 == null && (
                            <div>
                              <p>顔写真ファイルが存在しません。</p>
                            </div>
                          )}
                        </Col>
                      </Row>
                      {!読取専用フラグ && (
                        <Row className="m-1">
                          <Col>
                            <Button
                              className="w-4rem"
                              onClick={() => {
                                setSelected顔写真(zyomuinMaster.顔写真)
                                setIsShowFileUploadModal(true)
                              }}>
                              設定
                            </Button>
                            {zyomuinMaster.顔写真 && (
                              <Button
                                className="w-4rem ms-2 btn-secondary"
                                variant="caution"
                                onClick={(e) => {
                                  setSelected顔写真(zyomuinMaster.顔写真)
                                  setIsShowDeleteFileConfirmModal(true)
                                }}>
                                削除
                              </Button>
                            )}
                          </Col>
                        </Row>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <Table className="form-table">
                <tbody>
                  <tr>
                    <th className="min-w-8rem">郵便番号</th>
                    <td colSpan={3}>
                      <div className="input-group">
                        <TextInput
                          id="郵便番号"
                          name="郵便番号"
                          value={zyomuinMaster.郵便番号}
                          setValue={dummyFunc}
                          isReadOnly
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th className="min-w-8rem">現住所</th>
                    <td colSpan={3}>
                      <div className="input-group">
                        <TextInput
                          style={{ width: "50rem" }}
                          id="現住所"
                          name="現住所"
                          value={zyomuinMaster.住所}
                          setValue={dummyFunc}
                          isReadOnly
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th className="min-w-8rem">電話番号</th>
                    <td colSpan={3}>
                      <div className="input-group">
                        <TextInput
                          id="電話番号"
                          name="電話番号"
                          value={zyomuinMaster.電話番号}
                          setValue={dummyFunc}
                          isReadOnly
                          type="tel"
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th className="min-w-8rem">携帯電話番号</th>
                    <td colSpan={3}>
                      <div className="input-group">
                        <TextInput
                          id="携帯電話番号"
                          name="携帯電話番号"
                          value={zyomuinMaster.携帯電話番号}
                          setValue={dummyFunc}
                          isReadOnly
                          type="tel"
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th className="min-w-8rem">メールアドレス</th>
                    <td colSpan={3}>
                      <div className="input-group">
                        <TextInput
                          style={{ width: "30rem" }}
                          id="メールアドレス"
                          name="メールアドレス"
                          value={zyomuinMaster.携帯アドレス}
                          setValue={(v) => {
                            disPatch(zyomuinMasterActions.set携帯アドレス(v))
                          }}
                          isRequired
                          type="email"
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th className="min-w-8rem">緊急連絡先</th>
                    <td colSpan={3}>
                      <div className="input-group">
                        <TextInput
                          style={{ width: "50rem" }}
                          id="緊急連絡先"
                          name="緊急連絡先"
                          value={zyomuinMaster.緊急連絡先}
                          setValue={(v) => {
                            disPatch(zyomuinMasterActions.set緊急連絡先(v))
                          }}
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th className="min-w-8rem">緊急連絡先番号</th>
                    <td colSpan={3}>
                      <div className="input-group">
                        <TextInput
                          id="緊急連絡先電話番号"
                          name="緊急連絡先電話番号"
                          value={zyomuinMaster.緊急連絡先番号}
                          setValue={(v) => {
                            disPatch(
                              zyomuinMasterActions.set緊急連絡先電話番号(v)
                            )
                          }}
                          type="tel"
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th className="min-w-8rem">退職フラグ</th>
                    <td>
                      <div className="input-group">
                        <ComboBox.Default
                          isDisabled
                          itemsSource={退職フラグItemSource}
                          isLoadEnded={退職フラグIsLoadEnded}
                          selectedValue={zyomuinMaster.退職フラグ}
                          setSelectedValue={dummyFunc}
                          setIsLoadEnded={set退職フラグIsLoadEnded}
                          ComboBox={退職フラグComboBox}
                          setComboBox={
                            set退職フラグComboBox
                          }></ComboBox.Default>
                      </div>
                    </td>
                    <th className="min-w-8rem">退職年月日</th>
                    <td>
                      <div className="input-group">
                        <DateInput
                          id="退職年月日"
                          value={zyomuinMaster.退職年月日}
                          setValue={dummyFunc}
                          isDisabled
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th className="min-w-8rem">退職事由</th>
                    <td>
                      <div className="input-group">
                        <TextInput
                          style={{ width: "50rem" }}
                          id="退職事由"
                          name="退職事由"
                          value={zyomuinMaster.退職事由}
                          setValue={dummyFunc}
                          isReadOnly
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row>
            <Col>
              <h5>免許情報</h5>
              <Row>
                <Col>
                  <Table className="form-table">
                    <tbody>
                      <tr>
                        <th className="min-w-8rem">運転免許取得日</th>
                        <td colSpan={3}>
                          <WarekiInput
                            name="運転免許取得日"
                            value={zyomuinMaster.免許取得日}
                            setValue={(v) => {
                              disPatch(zyomuinMasterActions.set免許取得日(v))
                            }}
                            warekiPickerOuterStyle={{
                              height: "100%",
                              width: "2.5rem",
                              minHeight: "2rem",
                              paddingTop: "0.1rem",
                            }}></WarekiInput>
                        </td>
                        <th className="min-w-8rem">運転免許番号</th>
                        <td>
                          <TextInput
                            id="運転免許番号"
                            name="運転免許番号"
                            value={zyomuinMaster.免許証番号}
                            setValue={(v) => {
                              disPatch(zyomuinMasterActions.set免許証番号(v))
                            }}
                            maxLength={12}
                          />
                        </td>
                      </tr>

                      <tr>
                        <th className="min-w-8rem">種類</th>
                        <td colSpan={5}>
                          <div className="input-group">
                            <ul className="ps-0">
                              <li className="d-flex h-0rem">
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="大型免許フラグ"
                                    type={"checkbox"}
                                    label={"大型"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許大型フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許大型フラグ ?? 0}
                                  />
                                </div>
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="中型免許フラグ"
                                    type={"checkbox"}
                                    label={"中型"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許中型フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許中型フラグ ?? 0}
                                  />{" "}
                                </div>
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="普通免許フラグ"
                                    type={"checkbox"}
                                    label={"普通"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許普通フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許普通フラグ ?? 0}
                                  />{" "}
                                </div>
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="大型特殊免許フラグ"
                                    type={"checkbox"}
                                    label={"大特"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許大特フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許大特フラグ ?? 0}
                                  />{" "}
                                </div>
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="大型自動二輪免許フラグ"
                                    type={"checkbox"}
                                    label={"大自二"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許大自二フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許大自二フラグ ?? 0}
                                  />{" "}
                                </div>
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="普通自動二輪免許フラグ"
                                    type={"checkbox"}
                                    label={"普自二"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許普自二フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許普自二フラグ ?? 0}
                                  />{" "}
                                </div>
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="小型特殊免許フラグ"
                                    type={"checkbox"}
                                    label={"小特"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許小特フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許小特フラグ ?? 0}
                                  />{" "}
                                </div>
                              </li>
                              <li className="list-cmn d-flex h-0rem">
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="原付免許フラグ"
                                    type={"checkbox"}
                                    label={"原付"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許原付フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許原付フラグ ?? 0}
                                  />{" "}
                                </div>
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="けん引免許フラグ"
                                    type={"checkbox"}
                                    label={"け引"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許け引フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許け引フラグ ?? 0}
                                  />{" "}
                                </div>
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="大型二種免許フラグ"
                                    type={"checkbox"}
                                    label={"大二"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許大二フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許大二フラグ ?? 0}
                                  />{" "}
                                </div>
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="中型二種免許フラグ"
                                    type={"checkbox"}
                                    label={"中二"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許中二フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許中二フラグ ?? 0}
                                  />{" "}
                                </div>
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="普通二種免許フラグ"
                                    type={"checkbox"}
                                    label={"普二"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許普二フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許普二フラグ ?? 0}
                                  />{" "}
                                </div>
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="大型特殊二種免許フラグ"
                                    type={"checkbox"}
                                    label={"大特二"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許大特二フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許大特二フラグ ?? 0}
                                  />{" "}
                                </div>
                                <div className="border border-secondary w-5rem">
                                  <CheckInput
                                    id="けん引二種免許フラグ"
                                    type={"checkbox"}
                                    label={"け引二"}
                                    setValue={(v) =>
                                      disPatch(
                                        zyomuinMasterActions.set免許け引二フラグ(
                                          v
                                        )
                                      )
                                    }
                                    value={zyomuinMaster.免許け引二フラグ ?? 0}
                                  />{" "}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th className="min-w-8rem">免許条件1</th>
                        <td colSpan={5}>
                          <div className="input-group">
                            <TextInput
                              style={{ width: "30rem" }}
                              id="免許条件1"
                              name="免許条件1"
                              value={zyomuinMaster.免許条件1}
                              setValue={(v) => {
                                disPatch(zyomuinMasterActions.set免許条件1(v))
                              }}
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th className="min-w-8rem">免許条件2</th>
                        <td colSpan={5}>
                          <div className="input-group">
                            <TextInput
                              style={{ width: "30rem" }}
                              id="免許条件2"
                              name="免許条件2"
                              value={zyomuinMaster.免許条件2}
                              setValue={(v) => {
                                disPatch(zyomuinMasterActions.set免許条件2(v))
                              }}
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th className="min-w-8rem">免許条件3</th>
                        <td colSpan={5}>
                          <div className="input-group">
                            <TextInput
                              style={{ width: "30rem" }}
                              id="免許条件3"
                              name="免許条件3"
                              value={zyomuinMaster.免許条件3}
                              setValue={(v) => {
                                disPatch(zyomuinMasterActions.set免許条件3(v))
                              }}
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th className="min-w-8rem">運転記録最終取得日</th>
                        <td colSpan={5}>
                          <div className="input-group">
                            <DateInput
                              id="運転記録最終取得日"
                              value={zyomuinMaster.運転記録最終取得日}
                              setValue={(v) => {
                                disPatch(
                                  zyomuinMasterActions.set運転記録最終取得日(v)
                                )
                              }}
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th className="min-w-8rem">SDカード色</th>
                        <td colSpan={3}>
                          <div className="input-group">
                            <TextInput
                              id="SDカード色"
                              name="SDカード色"
                              value={zyomuinMaster.SDカード色}
                              setValue={(v) => {
                                disPatch(zyomuinMasterActions.setSDカード色(v))
                              }}
                            />
                          </div>
                        </td>
                        <th className="min-w-8rem">無事故年数</th>
                        <td>
                          <div className="input-group">
                            <NumberInput
                              style={{ width: "6rem" }}
                              id="無事故年数"
                              name="無事故年数"
                              min={0}
                              step={1}
                              value={zyomuinMaster.無事故年数}
                              setValue={(v) => {
                                disPatch(zyomuinMasterActions.set無事故年数(v))
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>

      <SingleFileUploadModal
        isShow={isShowFileUploadModal}
        setIsShow={setIsShowFileUploadModal}
        addItem={add顔写真}
        fileData={selected顔写真}
        isShowFileImage={true}
        fileImageUrl={
          selected顔写真 == null
            ? ""
            : blobList.find((b) => b.id === selected顔写真.row_id)?.fileUrl ??
              ""
        }
        title="顔写真"></SingleFileUploadModal>
      <ConfirmModal
        isShow={isShowDeleteFileConfirmModal}
        submitHandler={() => {
          remove顔写真(selected顔写真!)
          setIsShowDeleteFileConfirmModal(false)
        }}
        hideHandler={(isCancel) => {
          setIsShowDeleteFileConfirmModal(false)
        }}>
        <p>選択された写真を削除しますか？</p>
        <p>※実際の削除は登録ボタン押下時となります</p>
      </ConfirmModal>
    </>
  )
}

export default MainDataPane
